// @material-ui/icons
import SyncIcon from '@material-ui/icons/Sync';

// core components/views for Admin layout

import Synthetics from "views/Synthetic/Synthetic";
import Analytical from "views/Analytical/Analytical";
import SubSynthetic from "views/SubSynthetic/SubSynthetic";
import Debit from "views/Debit/Debit";

const dashboardRoutes = [
  {
    path: "/finance",
    name: "Finaceiro",
    icon: SyncIcon,
    component: Synthetics,
    layout: "/admin"
  },
  {
    path: "/synthetics",
    name: "Sintéticos",
    icon: SyncIcon,
    component: Synthetics,
    layout: "/admin"
  },
  {
    path: "/analytical",
    name: "Analítico",
    icon: SyncIcon,
    component: Analytical,
    layout: "/admin"
  },
  {
    path: "/subsynthetic",
    name: "SubSintetico",
    icon: SyncIcon,
    component: SubSynthetic,
    layout: "/admin"
  },
  {
    path: "/debit",
    name: "Lançamentos",
    icon: SyncIcon,
    component: Debit,
    layout: "/admin"
  }
];

export default dashboardRoutes;
